import { getCookie } from 'cookies-next';

/**
 * Authorization header for hh-v2 APIs that require the logged-in user.
 * In getServerSideProps pass the token read from the request cookie;
 * in the browser it falls back to the `token` cookie.
 */
export function bearerHeader(token?: string | null): Record<string, string> {
  const accessToken = token ?? (getCookie('token') as string | undefined);
  return accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
}
